module.exports = __webpack_public_path__ + "img/polo.29472e02.jpg";